window.youTubeIframeAPIReadyCallbacks.push(function() {
	var videoElements = document.querySelectorAll('.wp-block-zp4-cover .cover.has-video');
	var players = [];
	videoElements.forEach(function(videoElement, index) {
		var youtubeURL = videoElement.getAttribute('data-youtube-video-url');
		var videoId = youtubeURL.split('https://youtu.be/')[1];
		var placeholderId = 'video-placeholder-cover-' + index;
		var placeholderDiv = videoElement.querySelector('.video-placeholder');
		placeholderDiv.setAttribute('id', placeholderId);

		var parentContainer = videoElement.parentElement;
		var playerSettings = {
			videoId: videoId,
			events: {
				onReady: function(e) {
					e.target.mute();
				}
			}
		};

		if (parentContainer.matches('.wp-block-zp4-cover')) {
			playerSettings.playerVars = {
				autoplay: 1,
				controls: 0,
				showinfo: 0,
				modestbranding: 1,
				loop: 1,
				playlist: videoId,
				fs: 0,
				cc_load_policy: 0,
				iv_load_policy: 3,
				autohide: 0
			};
		}

		players[index] = new YT.Player(placeholderId, playerSettings);
	});
});
